import { reactive, ref } from 'vue';

import { CookieService } from '../services';

export function createState() {
  return reactive({
    isLogin: ref<boolean>(!!CookieService.GetSession()),
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onErrorClb: ref<(error: Error) => void>(() => {}),
  });
}
